import { render, staticRenderFns } from "./mortgage-term.vue?vue&type=template&id=1284fd10"
import script from "./mortgage-term.vue?vue&type=script&lang=js"
export * from "./mortgage-term.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports